define(function (require) {
    "use strict";

    var LE = require('app');
    var JsDiff = require('diff');
    var Diff2Html = require('diff2html').Diff2Html;

    var DiffUtil = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        DiffUtil = (function () {

            function generateDiffHtml(name, oldValue, newValue, options) {
                options = options || {};
                try {
                    oldValue = JSON.stringify(JSON.parse(oldValue), null, '\t');
                    newValue = JSON.stringify(JSON.parse(newValue), null, '\t');
                } catch (e) {
                    oldValue = oldValue && oldValue.replace(/<br\s*[\/]?>/gi, '\n');
                    newValue = newValue && newValue.replace(/<br\s*[\/]?>/gi, '\n');
                }
                var diff = JsDiff.createPatch(name || "", oldValue || "", newValue || "", "", "", { context: 10000000 });
                var diffHtml = Diff2Html.getPrettyHtml(diff, {
                    inputFormat: 'diff',
                    showFiles: false,
                    matching: 'lines',
                    outputFormat: ['side-by-side', 'line-by-line'].indexOf(options.outputFormat) > -1 ? options.outputFormat : 'side-by-side'
                });

                return diffHtml;
            }

            return {
                generateDiffHtml: generateDiffHtml
            };
        })();
    });

    return DiffUtil;
});
